import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import JobUsers from '../controls/JobUsers';
import JobDocuments from '../controls/JobDocuments';
import PropertiesContainer from './PropertiesContainer';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Link, Redirect } from 'react-router-dom';
import request from '../reducers/request';
import DivisionTree from '../controls/divisionTree';
import SelectedDivisions from '../controls/selectedDivisions';

const RequestJob = (props) => {
    let [job, setJob] = useState();
    let [divisions, setDivisions] = useState([]);
    let [selDivisions, setSelDivisions] = useState([]);

    const requestId = sessionStorage.getItem("requestId");

    const fetchData = async () => {
        if (!requestId)
            return;
        setJob(null);
        Comm.Instance().get(`job/getone?jobid=${props.match.params.jobId}`).then(result => {
            result.data.executionData = JSON.parse(result.data.executionData);
            result.data.defineData = JSON.parse(result.data.defineData);
            result.data.term = Tools.NormalizeDate(result.data.term);
            setJob(result.data);

        }).catch(error => Tools.ProcessError(error));
        Comm.Instance().get(`division`).then(result => {
            setDivisions(JSON.parse(result.data));

        }).catch(error => Tools.ProcessError(error));

        Comm.Instance().get(`job2division?jobid=${props.match.params.jobId}`).then(result => {
            setSelDivisions(result.data);

        }).catch(error => Tools.ProcessError(error));
    };
    useEffect(() => {

        fetchData();
    }, []);


    const setJobValue = (prop, val) => {
        if (val === "" && prop === "term") {
            val = null;
        }

        job[prop] = val;
        setJob({ ...job });
    }

    const setDefineValue = (id, value) => {

        var el = job.defineData.find(x => x.id === id);

        if (el) {
            el.value = value;
            setJob({ ...job });

        }

    };

    const setExecuteValue = (id, value) => {

        var el = job.executionData.find(x => x.id === id);

        if (el) {
            el.value = value;
            setJob({ ...job });

        }

    }

    const Save = (incState) => {
        if (incState) {
            job.jobStateId++;
            setJob({ ...job });
        }
        var newObj = { ...job };
        newObj.executionData = JSON.stringify(newObj.executionData);
        newObj.defineData = JSON.stringify(newObj.defineData);

        Comm.Instance().put("job", newObj).then(r =>
            toast.success("Успешен запис"))
            .catch(error =>
                Tools.ProcessError(error));
    }


    const SaveDivisions = () => {

        Comm.Instance().post(`job2division?jobId=${props.match.params.jobId}`, selDivisions.map(d => d.divisionId)).then(r =>
            toast.success("Успешен запис"))
            .catch(error =>
                Tools.ProcessError(error));
    }


    const addDivision = (d) => {
        if (!selDivisions.find(x => x.divisionId === d.DivisionId)) {
            selDivisions.push({
                divisionId: d.DivisionId,
                title: d.Title
            })
        }
        setSelDivisions([...selDivisions]);
    }

    const removeDivision = (id) => {
        selDivisions = selDivisions.filter(x => x.divisionId !== id)
        setSelDivisions([...selDivisions]);
    }

    if (!requestId) {
        return (<Redirect to="/MyJobs" />);
    }
    if (!job)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!job}
                />
            </div>
        );

    if (job.afterJobStateId && job.afterJobStateId !== 3)
        return (
            <div className="container">
                <h2 className="appeal-title mb-5">Неизпълнена дейност</h2>
                Дейност <Link to={"/RedirectTo/RequestJob%2F" + job.afterJobId}>{job.afterJobName}</Link>, която предхожда текущата е все още неизпълнена
            </div>
        );




    return (
        <div className="container">
            <h2 className="appeal-title mb-5">Заявление за издаване на удостоверение за статут по реда на ЗКН</h2>


            <Accordion multiple activeIndex={job.jobStateId === 1 ? "0" : "1"}>
                <AccordionTab header="Възлагане">
                    <div className="form-group col-md-12">
                        <label>Име</label>
                        <input type="text" value={job.name} onChange={(e) => setJobValue('name', e.target.value)} className="form-control" readOnly={job.jobStateId > 1} />
                    </div>
                    <div className="form-group col-md-12">
                        <label>Срок</label>
                        <input type="date" value={job.term} onChange={(e) => setJobValue('term', e.target.value)} className="form-control" readOnly={job.jobStateId > 1} />
                    </div>
                    <PropertiesContainer setPropertyValue={setDefineValue} readonly={job.jobStateId > 1} obj={job.defineData} />
                    {job.jobStateId === 1 ?
                        <div className="form-row">
                            <button className="btn btn-danger" onClick={() => Save(true)}>Възложи</button>
                            <button className="btn btn-primary" onClick={() => Save(false)}>Запис</button>
                        </div>
                        :
                        null
                    }
                </AccordionTab>
                <AccordionTab header="Изпълнение">
                    <PropertiesContainer setPropertyValue={setExecuteValue} readonly={!job.canEdit || job.jobStateId === 1 || job.jobStateId === 3} obj={job.executionData} />
                    {(job.jobStateId === 2) && (job.canEdit) ?
                        <div className="form-row">
                            <button className="btn btn-danger" onClick={() => Save(true)}>Изпълнена</button>
                            <button className="btn btn-primary" onClick={() => Save(false)}>Запис</button>
                        </div>
                        :
                        null
                    }
                </AccordionTab>
                <AccordionTab header="Отдели">
                    <div className="row">
                        <div className="col-md-6">
                            <DivisionTree divisions={divisions} sel={null} setSel={(d) => addDivision(d)} />
                        </div>
                        <div className="col-md-6">
                            <SelectedDivisions divisions={selDivisions} delDivision={(id) => removeDivision(id)} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button className="btn btn-primary" onClick={SaveDivisions}>Запис</button>
                        </div>
                    </div>


                </AccordionTab>
                <AccordionTab header="Документи">
                    <JobDocuments jobId={props.match.params.jobId} />
                </AccordionTab>
            </Accordion>


        </div>

    );
}


export default RequestJob;